// pass this function the needed data, and it will return all of the information needed to quote a pleated drapery

import { calculateWidths } from "./calculations/calculateWidths.js";
import { calculateCOM } from "./calculations/calculateCOM.js";
import { calculateCutLength } from "./calculations/calculateCutLength.js";
import { calculateFabricNeededForRepeat } from "./calculations/calculateFabricNeededForRepeat.js";

export function masterFunction(data) {
  console.log("masterFunction() start");

  //be careful to use result.totalWidths and not data.totalWidths in the calculations

  var result = {
    errors: [],
  };

  result.finishedWidth =
    data.rodWidth + data.leftReturn + data.rightReturn + data.overlap;

  result.totalWidths = calculateWidths(
    data.boltWidth,
    data.fullness,
    result.finishedWidth,
    data.panelOrPair
  );

  result.cutLength = calculateCutLength(data.finishedLength, data.lining);

  result.fabricNeededForRepeat = calculateFabricNeededForRepeat(
    result.cutLength,
    data.repeat
  );

  result.totalLength = result.cutLength + result.fabricNeededForRepeat;

  result.COMyardage = calculateCOM(
    result.totalWidths,
    result.cutLength,
    result.fabricNeededForRepeat
  );

  console.log("masterFunction() end");
  console.log(result);
  console.log("////////////////////////////////////////////");
  return result;
}
